// src/components/Calendar/MonthPicker.tsx

import type React from "react";
import { MONTH_NAMES_SHORT } from "./utils";

interface MonthPickerProps {
  currentMonth: number;
  onSelect: (month: number) => void;
}

export function MonthPicker({ currentMonth, onSelect }: MonthPickerProps) {
  return (
    <div style={gridStyle}>
      {MONTH_NAMES_SHORT.map((name, idx) => {
        const isCurrent = idx === currentMonth;
        return (
          <button
            type="button"
            key={name}
            onClick={() => onSelect(idx)}
            style={{
              ...btnStyle,
              background: isCurrent ? "#263238" : "transparent",
              color: isCurrent ? "#ffffff" : "#0E1A1A",
              fontWeight: isCurrent ? 700 : 500,
            }}
            onMouseEnter={(e) => { if (!isCurrent) (e.currentTarget as HTMLElement).style.background = "#F3F5F5"; }}
            onMouseLeave={(e) => { if (!isCurrent) (e.currentTarget as HTMLElement).style.background = "transparent"; }}
          >
            {name}
          </button>
        );
      })}
    </div>
  );
}

const gridStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gap: 4,
  padding: 6,
};

const btnStyle: React.CSSProperties = {
  padding: "10px 0",
  textAlign: "center",
  fontSize: 13,
  cursor: "pointer",
  borderRadius: 6,
  border: 0,
  fontFamily: "inherit",
};